import { Component, OnInit } from '@angular/core';
import { UserDao } from '@app/dao/user/user.dao';
import {
  investmentDurationOptions,
  investmentGoalsOptions,
  patrimonyValueOptions,
  riskToleranceOptions,
} from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { take } from 'rxjs';
import riskStatus from '../../risk-status';

@Component({
    selector: 'profile-summary',
    templateUrl: './profile-summary.component.html',
    styleUrls: ['./profile-summary.component.scss'],
    standalone: false
})
export class ProfileSummaryComponent implements OnInit {
  description: string = '';
  homeTitle: string = 'Votre foyer';
  investorTitle: string = 'Votre parcours d’investisseur';
  homeOptions: string[] = [];

  investorOptions: string[] = [];
  value = { min: 30, max: 80 };
  user;
  riskRange;
  riskStatus: string = '';

  minRiskThreshold = 3;
  maxRiskThreshold = 4;
  recommendedEuroFoundShareMin: number;
  recommendedEuroFoundShareMax: number;
  productType = '';
  constructor(
    private subscriptionFacade: SubscriptionFacadeService,
    private useDao: UserDao,
  ) {}

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.productType = pledge?.productType;
    const owners = pledge?.owners;
    this.useDao
      .getAuthentified()
      .pipe(take(1))
      .subscribe(user => {
        const { children, userBirthDate, userMaritalSituation, riskProfil } =
          owners?.find(owner => owner.id === user.id) || owners?.[0] || {};
        const { monthlySaving, investmentGoals, epargnePrecaution } =
          pledge.accountInformations;
        const {
          score,
          patrimonyValue,
          riskTolerance,
          recommendedEuroFoundShareMax,
          recommendedEuroFoundShareMin,
        } = riskProfil;
        this.riskRange = [1, score || 5];
        this.recommendedEuroFoundShareMax = recommendedEuroFoundShareMax;
        this.recommendedEuroFoundShareMin = recommendedEuroFoundShareMin;
        this.value = {
          min: recommendedEuroFoundShareMin * 100,
          max: recommendedEuroFoundShareMax * 100,
        };
        this.riskStatus = riskStatus.getRiskStatus(score);
        this.description = riskStatus.getRiskDescription(score);
        const age =
          new Date().getFullYear() - new Date(userBirthDate).getFullYear();
        this.homeOptions.push(`Vous avez ${age} ans.`);

        if (userMaritalSituation === 'MARRIED') {
          this.homeOptions.push('Vous êtes marié.');
        } else {
          this.homeOptions.push("Vous n'êtes pas marié.");
        }

        children &&
          children !== 'NONE' &&
          this.homeOptions.push(
            `Vous avez ${this.getChildrenLabel(children)} enfant(s) à charge.`,
          );

        patrimonyValue &&
          this.homeOptions.push(
            `Votre patrimoine est estimé ${this.getPatrimonyValueOptions(
              patrimonyValue,
            )} .`,
          );
        monthlySaving &&
          this.homeOptions.push(
            `Votre capacité d'épargne annuelle est estimée à ${
              ~~monthlySaving * 12
            }  €.`,
          );
        epargnePrecaution &&
          this.homeOptions.push(
            `Votre épargne de précaution est de ${epargnePrecaution} €.`,
          );

        // this.homeOptions = [
        //   `Vous avez ${age} ans.`,
        //   "Vous êtes marié.",
        //   "Vous avez 2 enfants à charge.",
        //   "Votre patrimoine est estimé à xxx xxx €.",
        //   "Votre capacité d’épargne annuelle se situe entre xx xxx et xx xxx €.",
        // ];
        const { investmentDuration } = pledge.parameters;
        // investorOptions= [
        //   "Votre objectif est de préparer votre retraite et de constituer une épargne.",
        //   "Vous souhaitez investir plus de 8 ans.",
        //   "Vous aversion au risque est plutôt élevée.",
        //   "Votre connaissance des marchés financiers est moyenne.",
        // ];
        investmentGoals &&
          this.investorOptions.push(
            `Votre objectif est de ${this.getInvestmentGoals(investmentGoals)}`,
          );
        investmentDuration &&
          this.investorOptions.push(
            `Vous souhaitez investir  ${this.getInvestmentDurationLabel(
              investmentDuration,
            )} .`,
          );
        riskTolerance &&
          this.investorOptions.push(
            `Votre aversion au risque est ${this.getRiskToleranceLabel(
              riskTolerance,
            )}.`,
          );
      });
  }
  getChildrenLabel(children) {
    return children;
    //return childrenOptions.find((option) => option.value === children)?.label;
  }
  getPatrimonyValueOptions(patrimonyValue) {
    return patrimonyValueOptions.find(option => option.value === patrimonyValue)
      .label;
  }
  getInvestmentGoals(investmentGoals: string[]) {
    if (!investmentGoals.length) return '';
    return investmentGoalsOptions
      .filter(option => investmentGoals.includes(option.value))
      .map(option => option?.label.toLowerCase())
      .join(' et ');
  }
  getInvestmentDurationLabel(investmentDuration) {
    if (!investmentDuration) return '';
    const label = investmentDurationOptions.find(
      option => option?.value === investmentDuration,
    ).label;
    return label?.toLowerCase() || '';
  }
  getRiskToleranceLabel(riskTolerance) {
    if (!riskTolerance) return '';
    const label = riskToleranceOptions.find(
      option => option?.value === riskTolerance,
    ).label;

    const lastWord = label?.split(' ').pop();
    return lastWord?.toLowerCase() || '';
  }
}
